import React, { PropsWithChildren, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { CabinetInfoContext } from '../../../context/cabinet'
import { useAppDispatch } from '../../../store/hooks'
import { loadCabinetInfo } from '../../../store/cabinet/thunk'
import { useCabinetInfo } from '../../../store/selectors/cabinet'
import { setCabinetInfo } from '../../../store/cabinet/reduser'
import styles from './cabinets.module.scss'
import BoxUi from '../../ui/BoxUi/BoxUi'
import ButtonUi from '../../ui/ButtonUi/ButtonUi'
import { routersPath } from '../../../router/routes-path'
import { useNavigate } from 'react-router'

export const CabinetInfoProvider: React.FC<PropsWithChildren> = ({
  children
}) => {
  const dispatch = useAppDispatch();
  const { cabinetId } = useParams<{ cabinetId: string }>()
  const { cabinetInfo, loading } = useCabinetInfo();

  const navigate = useNavigate()

  useEffect(() => {
    dispatch(loadCabinetInfo(cabinetId));

    return () => {
      dispatch(setCabinetInfo(null));
    }
  }, []);

  if (!cabinetInfo) {
    if (loading) {
      return null;
    }

    return (
      <BoxUi className={styles.notFound}>
        <div className={styles.header}>
          <p className={styles.title}>
            Информация о клиенте
          </p>
        </div>
        <div className={styles.text}>
          <h2>
            Кабинет не найден <br /> или <br />возникла ошибка при его загрузке
          </h2>
          <ButtonUi onClick={() => navigate(routersPath.CABINETS, { replace: true })}>
            Перейти к списку кабинетов
          </ButtonUi>
        </div>
      </BoxUi>
    )
  }

  return (
    <CabinetInfoContext.Provider value={{ cabinetInfo }}>
      {children}
    </CabinetInfoContext.Provider>
  )
}
